import styled from "styled-components";

export const AvailableTicketCountBadgeDefaultBox = styled.div<{bigSize: boolean}>`
    position: absolute;
    right: -2px;
    top: -2px;
    font-size: 1rem;
    transition: width 0.4s ease-in, height 0.4s ease-in;
    width: ${props => props.bigSize ? 1.8 : 1.6}rem;
    height: ${props => props.bigSize ? 1.8 : 1.6}rem;
    border-radius: 50%;
    color: white;
    /** In new games badge the color is backgroundInGridLayout: "#FF014F", maybe we should make the same */
    background-color: #9747FF;
    text-align: center;
    line-height: 1;
    padding-top: ${props => props.bigSize ? 0.4 : 0.3}rem;
`;
